var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -312,
    y: -569,
    width: 390,
    height: 844,
    rx: 40,
    fill: "#F6EDE5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 124,
    cy: -411,
    rx: 332,
    ry: 264,
    fill: "#FFD4BC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -251,
    cy: -140.5,
    rx: 197,
    ry: 156.5,
    fill: "#F0BA9B"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -270.5,
    y: -16.5,
    width: 307,
    height: 47,
    rx: 15.5,
    fill: "white",
    stroke: "#D9DCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 4C9.21097 4.00524 8.45503 4.32299 7.89657 4.88447C7.33811 5.44595 7.02206 6.20597 7.01685 7C7.01685 8.642 8.36755 10 10.0007 10C11.6329 10 12.9846 8.642 12.9846 7C12.9846 5.359 11.6329 4 10.0007 4Z",
    fill: "#D9DCDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C2.408 0 0.126318 6.617 0.105431 6.684L0 7L0.104436 7.316C0.126318 7.383 2.408 14 10 14C17.592 14 19.8737 7.383 19.8946 7.316L20 7L19.8956 6.684C19.8737 6.617 17.592 0 10 0ZM10 12C4.67774 12 2.61587 8.154 2.11657 7C2.61786 5.842 4.68072 2 10 2C15.3223 2 17.3841 5.846 17.8834 7C17.3821 8.158 15.3193 12 10 12Z",
    fill: "#D9DCDF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -317,
    y: -574,
    width: 400,
    height: 854,
    rx: 45,
    stroke: "#FFEDED",
    strokeOpacity: 0.19,
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: -630,
    y: -1097,
    width: 1508,
    height: 1372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 211,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1",
    x: -870,
    y: -719,
    width: 1238,
    height: 1157,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 211,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -312,
    y: -569,
    width: 390,
    height: 844,
    rx: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.0eac635b0e7f2575f2da146e78d583cf.svg";
export { ForwardRef as ReactComponent };